import { useEffect, useState } from "react";
import IconButton from "../../../../components/IconButton";
import { ModalPopUp } from "../../../../components/ModalPopUp";
import useAuthData from "../../../../hook/useAppData";
import { IconPencil } from "../../../../icons";
import { IListRoleInProject } from "../../model";
import { getRoleInProject } from "../../service";
import FormRoleInProject from "../Form";
import "./index.scss";

export function ListRoleInProject() {
  const { token } = useAuthData();
  const [listRoleInProject, setListRoleInProject] = useState<IListRoleInProject[]>();
  const [needForm, setNeedForm] = useState<IListRoleInProject>();
  const [modalStatus, setModalStatus] = useState<boolean>();

  const handleClickCancel = () => {
    setNeedForm(undefined);
    setModalStatus(false);
    getRolesInProject();
  };

  useEffect(() => {
    getRolesInProject();
  }, []);

  async function getRolesInProject() {
    const res = await getRoleInProject({ token });
    setListRoleInProject(res);
  }

  return (
    <>
      <ModalPopUp
        title={needForm?.name ? `Editar - ${needForm?.name}` : "Adicionar Função no Projeto"}
        status={modalStatus}
        onClickCancel={() => handleClickCancel()}
      >
        <FormRoleInProject info={needForm} exit={handleClickCancel} />
      </ModalPopUp>
      <div className="listRoleInProject container">
        <div className="listRoleInProject__header box-title">
          <h1 className="title-form">Função no Projeto</h1>
          <button
            type="button"
            className="btn bg-primary"
            onClick={() => {
              setModalStatus(true);
            }}
          >
            Nova Função do Projeto
          </button>
        </div>
        <div className="table-container-full box-shadow">
          <table className="table-container-header-body">
            <thead>
              <tr>
                <th className="header-left">Função</th>
                <th className="col-function header-center">Editar</th>
              </tr>
            </thead>
            <tbody>
              {listRoleInProject?.map((role, index) => {
                return (
                  <tr className={index % 2 !== 0 && "rowGrey"}>
                    <td>{role?.name} </td>
                    <td className="col-function">
                      <IconButton
                        className="row-trash icon-pencil"
                        icon={IconPencil}
                        onClick={() => {
                          setModalStatus(true);
                          setNeedForm(role);
                        }}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
